import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/log`;

class LogService {
  getEmailSubmission(loanNumber) {
    return axios.get(`${API_URL}/EmailSubmission?loanNumber=${loanNumber}`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response.data;
    });
  }
}

export default new LogService();